import { Typography } from "antd";
import { companyBlock, intro, lastUpdated, legalTitle, sectionBody, sectionHeading } from "../LegalPage.styles.ts";

const { Title, Paragraph, Text } = Typography;

export const TermsBg = () => (
  <article>
    <Title className={legalTitle} level={1}>
      Условия за ползване
    </Title>
    <Text className={lastUpdated}>Последна актуализация: 6 май 2026 г.</Text>

    <Paragraph className={intro}>
      Настоящите Условия за ползване („Условията“) уреждат достъпа до и ползването на услугата Calculabel („Услугата“),
      предоставяна от <strong>Фууд Сейфти Консултинг ЕООД</strong> („Calculabel“, „ние“) — дружество с ограничена
      отговорност, регистрирано в България с ЕИК 204435984, със седалище ул. Тракия № 34, 1527 София. Със създаването на
      профил или с друго ползване на Услугата приемате тези Условия. Ако не сте съгласни с тях, моля не използвайте
      Услугата.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      1. Приемане и обхват
    </Title>
    <Paragraph className={sectionBody}>
      Тези Условия представляват обвързващо споразумение между вас и Calculabel и се прилагат за всички посетители и
      регистрирани потребители. Ако приемате Условията от името на организация (екип), вие декларирате, че имате
      правомощието да я обвържете, като „вие“ означава както вашата личност, така и организацията.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      2. Услугата
    </Title>
    <Paragraph className={sectionBody}>
      Calculabel е софтуер като услуга (SaaS) за професионалисти в храните и за домашни потребители. Включва управление
      на рецепти и съставки, изчисляване на хранителна стойност, проследяване на съставки и производители, генериране на
      хранителни и винени етикети, създаване на QR-етикети, проследяване на покупки и планиране на хранения. Конкретният
      набор от функции зависи от плана ви; възможно е във времето да добавяме, променяме или прекратяваме функции, както
      е посочено в тези Условия.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      3. Профил и регистрация
    </Title>
    <Paragraph className={sectionBody}>
      За да използвате повечето функции, е необходимо да създадете профил. Удостоверяването е без парола, чрез
      еднократни краткотрайни връзки, изпратени на имейла ви. Вие отговаряте за сигурността на собствения си имейл, за
      поверителността на получените връзки за вход и за всички действия, извършени от вашия профил. Ако подозирате
      неоторизиран достъп, незабавно ни уведомете на <a href="mailto:support@calculabel.com">support@calculabel.com</a>.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      4. Вашето съдържание
    </Title>
    <Paragraph className={sectionBody}>
      Запазвате всички права върху съдържанието, което създавате или качвате в Услугата („Потребителско съдържание“) —
      рецепти, съставки, производители, файлове, етикети. С ползването на Услугата предоставяте на Calculabel
      неизключителен, безвъзмезден лиценз с глобално действие за хостване, съхранение, възпроизвеждане, предаване,
      показване и обработка на Потребителското съдържание единствено доколкото това е необходимо за работата на Услугата
      за вас и вашия екип. Декларирате, че разполагате с всички необходими права за качване на Потребителското
      съдържание и че то не нарушава права на трети лица или приложимото право.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      5. Допустимо ползване
    </Title>
    <div className={sectionBody}>
      <Paragraph>Задължавате се да не:</Paragraph>
      <ul>
        <li>използвате Услугата за незаконни, измамни или вредни цели;</li>
        <li>качвате съдържание, което е незаконно, клеветническо или нарушава чужди права;</li>
        <li>правите опити за неоторизиран достъп до Услугата, профили или системите в нейна основа;</li>
        <li>
          извличате масово, копирате или подлагате Услугата на обратно инженерство, освен доколкото това се допуска по
          императивно право;
        </li>
        <li>се представяте за друго лице или невярно представяте принадлежност;</li>
        <li>пречите на целостта, сигурността или производителността на Услугата;</li>
        <li>използвате Услугата за изпращане на спам, зловреден код или друг вреден трафик;</li>
        <li>заобикаляте технически ограничения, лимити на честотата или контрол на достъпа.</li>
      </ul>
    </div>

    <Title className={sectionHeading} level={4}>
      6. Планове и заплащане
    </Title>
    <Paragraph className={sectionBody}>
      Calculabel предлага планове Безплатен, Базов и All-Inclusive. Цените на платените планове ще бъдат обявени на
      страницата с цени и представени при сключване на абонамент. След активиране на платените планове таксите се
      заплащат предварително за избрания период и се подновяват автоматично, освен при отказ преди датата на
      подновяване. Може да променяме функциите и цените на плановете с разумно предварително уведомление. Законовите
      потребителски права на отказ съгласно правото на ЕС и Република България остават незасегнати от тези Условия.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      7. Достъпност на Услугата и промени
    </Title>
    <Paragraph className={sectionBody}>
      Стремим се да поддържаме Услугата с максимални усилия, но на този етап не поемаме конкретни ангажименти за време
      на работа. Възможни са планирана профилактика и непланиран престой. Може да добавяме, променяме или прекратяваме
      функции; при промени, които съществено засягат платените функции, ще предоставим разумно предварително
      уведомление.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      8. Важна забележка — хранителни стойности и етикетиране
    </Title>
    <Paragraph className={sectionBody}>
      <strong>
        Хранителните стойности, обозначенията на алергени и другото етикетно съдържание, генерирано от Услугата, са
        изчислени стойности, базирани на въведените от вас или от трети страни данни за съставки, рецепти и референтни
        бази. Те се предоставят само за информационни и оперативни цели и не представляват сертифицирани лабораторни
        анализи.
      </strong>
    </Paragraph>
    <Paragraph className={sectionBody}>
      <strong>
        Вие носите изцяло отговорност за точността, пълнотата и съответствието с приложимото право на всеки хранителен
        или винен етикет, хранителна декларация, списък на съставки, обозначение за алергени, съдържание, достъпно чрез
        QR код, или друга регулирана информация, генерирана чрез Услугата, включително за съответствие с Регламент (ЕС)
        № 1169/2011 за предоставянето на информация за храните на потребителите и приложимите национални изисквания.
      </strong>{" "}
      Услугата се предоставя „както е“ и „при наличност“, без гаранция за пригодност за дадена цел или съответствие с
      регулаторни изисквания, до максималната допустима степен по приложимото право.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      9. Ограничаване на отговорността
    </Title>
    <Paragraph className={sectionBody}>
      До максималната степен, допустима по българското право, Calculabel не носи отговорност за непреки, случайни,
      специални, последващи или наказателни вреди, пропуснати ползи, загубени данни или загуба на доброто име,
      произтичащи от или във връзка с ползването на Услугата. Общата ни отговорност по който и да е иск, свързан с тези
      Условия, не надвишава общата сума, която сте ни заплатили за Услугата през дванадесетте (12) месеца преди
      настъпването на събитието, дало основание за иска, или, ако ползвате безплатен план — петдесет (50) евро. Нищо в
      тези Условия не ограничава отговорност, която не може да бъде ограничена съгласно императивни норми на българското
      право.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      10. Прекратяване
    </Title>
    <Paragraph className={sectionBody}>
      Може да закриете профила си по всяко време. Ние може да спрем или прекратим достъпа ви при съществено нарушение на
      тези Условия, при законово изискване или при риск за сигурността или законосъобразността на Услугата. След
      прекратяване правото ви да ползвате Услугата отпада незабавно. Клаузите, които по своя характер следва да
      продължат да действат — лицензът върху Потребителското съдържание в обхвата, необходим за резервни копия,
      ограниченията на отговорността и приложимото право — остават в сила и след прекратяване.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      11. Приложимо право и подсъдност
    </Title>
    <Paragraph className={sectionBody}>
      Тези Условия се уреждат от законите на Република България, без оглед на стълкновителните им норми. Всички спорове,
      произтичащи от или във връзка с тези Условия или Услугата, са подсъдни на компетентните съдилища в София,
      България, освен когато императивни норми за защита на потребителите ви предоставят правото да предявите иск в
      държавата, в която живеете.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      12. Промени в Условията
    </Title>
    <Paragraph className={sectionBody}>
      Възможно е да актуализираме тези Условия периодично. Датата „Последна актуализация“ най-горе отразява последната
      версия. При съществени промени ще предоставим разумно предварително уведомление — например чрез банер в
      приложението или имейл до регистрираните потребители. Продължаването на ползването на Услугата след влизане в сила
      на актуализацията означава приемане на актуализираните Условия.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      13. Контакт
    </Title>
    <Paragraph className={sectionBody}>
      Въпроси по тези Условия? Пишете ни на <a href="mailto:support@calculabel.com">support@calculabel.com</a>.
    </Paragraph>

    <Paragraph className={companyBlock}>
      Доставчик на услугата: Фууд Сейфти Консултинг ЕООД
      <br />
      ЕИК: 204435984
      <br />
      ДДС №: BG204435984
      <br />
      Адрес: ул. Тракия № 34, 1527 София, България
      <br />
      Имейл: <a href="mailto:support@calculabel.com">support@calculabel.com</a>
    </Paragraph>
  </article>
);
